import { createMiddleware } from '@tanstack/react-start';
import { getRequest } from '@tanstack/react-start/server';
import {
  ATTR_HTTP_REQUEST_METHOD,
  ATTR_HTTP_ROUTE,
  ATTR_URL_FULL,
  ATTR_URL_PATH,
} from '@opentelemetry/semantic-conventions';
import { Effect } from 'effect';
import { serverRuntime } from '../runtimes/server-runtime.server';

// Wraps TanStack server functions in an Effect span so SQL queries and auth
// calls inherit the request trace. type: 'function' is required for global
// functionMiddleware registration in start.ts.
export const otelMiddleware = createMiddleware({ type: 'function' }).server(
  ({ next }) => {
    const request = getRequest();
    const url = new URL(request.url);
    const spanName = `http.server ${request.method}`;

    return serverRuntime.runPromise(
      Effect.promise(() => Promise.resolve(next())).pipe(
        Effect.withSpan(spanName, {
          attributes: {
            [ATTR_HTTP_REQUEST_METHOD]: request.method,
            [ATTR_URL_PATH]: url.pathname,
            [ATTR_URL_FULL]: request.url,
            [ATTR_HTTP_ROUTE]: `serverFn:${url.pathname}`,
          },
        }),
      ),
    );
  },
);
